import { setStreemLogger } from './streem_logger';
export function configureChimeVideo({ logger }) {
    setStreemLogger(logger);
}
//# sourceMappingURL=configure.js.map